<form nz-form [nzLayout]="'vertical'" [formGroup]="form" (ngSubmit)="applyHandler()">
    <nz-row [nzGutter]="[12, 0]">
        <ng-container *ngFor="let field of data.fields; let index = index">
            <nz-col [nzXs]="24" [nzSm]="24" [nzMd]="24" [nzLg]="field.columnWidth || 24"
                [nzXl]="field.columnWidth || 24">
                <ng-container [ngSwitch]="field.type">
                    <ng-container *ngSwitchCase="'checkbox'">
                        <nz-form-item>
                            <nz-form-label [nzFor]="field.name">{{ field.label }}</nz-form-label>
                            <nz-form-control [nzErrorTip]="getErrorMessage(field.name, field)">
                                <nz-checkbox-group [id]="field.name" [formControlName]="field.name"></nz-checkbox-group>
                            </nz-form-control>
                        </nz-form-item>
                    </ng-container>
                    <ng-container *ngSwitchCase="'select'">
                        <ng-container *ngIf="field.optionsAsync !== false && field.options !== undefined">
                            <ng-container *ngIf="field.multiple && field.optionsAsync">
                                <nz-form-item>
                                    <nz-form-label [nzFor]="field.name">{{ field.label }}</nz-form-label>
                                    <nz-form-control [nzErrorTip]="getErrorMessage(field.name, field)">
                                        <ng-container *ngIf="(field.options | async) as asyncOptions; else multiSelectLoadingTemplate">
                                            <nz-select [formControlName]="field.name" [id]="field.name" nzShowSearch selectAllValue="SELECT_ALL"
                                                [nzMode]="field.multiple ? 'multiple' : 'default'" [nzPlaceHolder]="field?.placeholder || ''"
                                                [nzMaxTagCount]="1" nzAllowClear [control]="form.get(field.name)" [options]="asyncOptions"
                                                [appSelectAll]="asyncOptions">
                                                <nz-option *ngIf="asyncOptions?.length && field.multiple" nzValue="SELECT_ALL"
                                                    nzLabel=" ----- SELECT ALL ----- "></nz-option>
                                                <nz-option *ngFor="let option of asyncOptions || []" [nzValue]="option.value"
                                                    [nzLabel]="option.label"></nz-option>
                                            </nz-select>
                                        </ng-container>
                                    </nz-form-control>
                                </nz-form-item>
                                <ng-template #multiSelectLoadingTemplate>
                                    <nz-select class="w-11/12" [nzPlaceHolder]="field?.placeholder || ''" [nzLoading]="true"></nz-select>
                                </ng-template>
                            </ng-container>
                            <ng-container *ngIf="!field.multiple && field.optionsAsync">
                                <nz-form-item>
                                    <nz-form-label [nzFor]="field.name">{{ field.label }}</nz-form-label>
                                    <nz-form-control [nzErrorTip]="getErrorMessage(field.name, field)">
                                        <ng-container *ngIf="(field.options | async) as asyncOptions; else singleSelectLoadingTemplate">
                                            <nz-select [formControlName]="field.name" [id]="field.name" nzShowSearch selectAllValue="SELECT_ALL"
                                                [nzMode]="field.multiple ? 'multiple' : 'default'" [nzPlaceHolder]="field?.placeholder || ''"
                                                [nzMaxTagCount]="1" nzAllowClear>
                                                <nz-option *ngFor="let option of asyncOptions || []" [nzValue]="option.value"
                                                    [nzLabel]="option.label"></nz-option>
                                            </nz-select>
                                        </ng-container>
                                    </nz-form-control>
                                </nz-form-item>
                                <ng-template #singleSelectLoadingTemplate>
                                    <nz-select class="w-11/12" [nzPlaceHolder]="field?.placeholder || ''" [nzLoading]="true"></nz-select>
                                </ng-template>
                            </ng-container>
                        </ng-container>
                        <ng-container *ngIf="!field.optionsAsync && field.options as staticOptions">
                            <nz-form-item>
                                <nz-form-label [nzFor]="field.name">{{ field.label }}</nz-form-label>
                                <nz-form-control [nzErrorTip]="getErrorMessage(field.name, field)">
                                    <nz-select [formControlName]="field.name" [id]="field.name" nzShowSearch selectAllValue="SELECT_ALL"
                                        [nzMode]="field.multiple ? 'multiple' : 'default'" [nzPlaceHolder]="field?.placeholder || ''"
                                        [nzMaxTagCount]="1" nzAllowClear [control]="form.get(field.name)" [options]="staticOptions"
                                        [appSelectAll]="staticOptions">
                                        <nz-option *ngIf="staticOptions?.length && field.multiple" nzValue="SELECT_ALL"
                                            nzLabel=" ----- SELECT ALL ----- "></nz-option>
                                        <nz-option *ngFor="let option of staticOptions || []" [nzValue]="option.value"
                                            [nzLabel]="option.label"></nz-option>
                    
                                    </nz-select>
                                </nz-form-control>
                            </nz-form-item>
                        </ng-container>
                    </ng-container>
                    <ng-container *ngSwitchCase="'p-select'">
                        <nz-form-item>
                            <nz-form-label [nzFor]="field.name">{{ field.label }}</nz-form-label>
                            <nz-form-control [nzErrorTip]="getErrorMessage(field.name, field)">
                                <nz-select [nzMode]="field.multiple ? 'multiple' : 'default'" [formControlName]="field.name" [id]="field.name" nzShowSearch
                                    [nzPlaceHolder]="field?.placeholder || ''" [nzMaxTagCount]="1" nzAllowClear (nzScrollToBottom)="loadMore(field)" [nzDropdownRender]="renderTemplate">
                                    <nz-option *ngFor="let option of pSelectOptions[field.name] || []" [nzValue]="option.value" [nzLabel]="option.label"></nz-option>
                                </nz-select>
                                <ng-template #renderTemplate>
                                    <nz-spin *ngIf="isLoading"></nz-spin>
                                </ng-template>
                            </nz-form-control>
                        </nz-form-item>
                    </ng-container>
                    <ng-container *ngSwitchCase="'text'">
                        <nz-form-item>
                            <nz-form-label [nzFor]="field.name">{{ field.label }}</nz-form-label>
                            <nz-form-control [nzErrorTip]="getErrorMessage(field.name, field)">
                                <input nz-input [formControlName]="field.name" [id]="field.name" [placeholder]="field.placeholder" />
                            </nz-form-control>
                        </nz-form-item>
                    </ng-container>
                </ng-container>
            </nz-col>
        </ng-container>
    </nz-row>
    
    <nz-divider class="mt-0 mb-6"></nz-divider>

    <div nz-flex [nzJustify]="'space-between'" [nzAlign]="'flex-start'">
        <button nz-button type="button" nzType="default" (click)="resetHandler()">Reset</button>
        <button nz-button type="submit" nzType="primary">Apply</button>
    </div>
</form>